<template>
  <section class="listing">
    <div class="header">
      <div class="title">Configuração</div>
    </div>

    <transition name="show" mode="out-in">
      <i v-if="loading" class="fas fa-spinner loading-big"></i>
      <form v-else @submit.prevent="save" class="form config-form">
        <label>Limite de dias do indicador cheio para dar desconto</label>
        <input
          v-model.number="indicatorFullDiscountDays"
          type="number"
          min="0"
          max="365"
          step="1"
          placeholder="Ex: 25"
          :class="{ error : error.includes('indicatorFullDiscountDays') }"
        />
        <div v-if="error.includes('indicatorFullDiscountDays')" class="hint">Informe um valor entre 0 e 365</div>
        <div class="hint hint-info">
          A 2ª assinatura/renovação só recebe desconto se a assinatura de indicador (valor cheio) ainda tiver pelo menos essa quantidade de dias até o vencimento.
        </div>

        <div v-if="errorMsg" class="hint">{{ errorMsg }}</div>
        <div v-if="saved" class="hint hint-ok">Parâmetro salvo.</div>
        <button type="submit" class="button-save" style="margin-top: 20px">
          <i class="fas" :class="saving ? 'fa-spinner loading' : 'fa-check'"></i><span>Salvar</span>
        </button>
      </form>
    </transition>
  </section>
</template>

<script>
import logger from '../../logger'
import { getParameters, updateParameters } from '../api/systemParameter'

export default {
  name: 'SystemConfig',
  data () {
    return {
      loading: true,
      saving: false,
      error: [],
      errorMsg: null,
      saved: false,
      indicatorFullDiscountDays: 25
    }
  },
  async mounted () {
    await this.load()
  },
  methods: {
    async load () {
      this.loading = true
      this.errorMsg = null
      try {
        const data = await getParameters()
        const days = Number(data && data.indicatorFullDiscountDays)
        this.indicatorFullDiscountDays = Number.isNaN(days) ? 25 : days
      } catch (error) {
        logger.error(error, this)
        this.errorMsg = 'Erro ao carregar parâmetros.'
      }
      this.loading = false
    },
    async save () {
      this.error = []
      this.errorMsg = null
      this.saved = false
      const days = Number(this.indicatorFullDiscountDays)
      if (Number.isNaN(days) || days < 0 || days > 365 || !Number.isInteger(days)) {
        this.error.push('indicatorFullDiscountDays')
        return
      }
      this.saving = true
      try {
        const data = await updateParameters(days)
        this.indicatorFullDiscountDays = Number(data.indicatorFullDiscountDays)
        this.saved = true
      } catch (error) {
        logger.error(error, this)
        const data = error && error.response && error.response.data
        if (data && data.fields) this.error = data.fields
        this.errorMsg = (data && data.error) || 'Erro ao salvar. Tente novamente.'
      }
      this.saving = false
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../_asset/scss/_variables";

.config-form {
  max-width: 520px;
  padding: 0 5px;
}

.hint-info {
  margin-top: 8px;
  color: $lp-text-2;
}

.hint-ok {
  color: #3d8a46;
}
</style>
